export enum CustomActionBarTypeEnum {
  NEW,
  CLOSE,
  SAVE,
  SAVE_CLOSE,
  REFRESH,
  DELETE,
  UPLOAD
}
